import { Entity } from "src/app/core/data/schema/entity";
import { Dictionary } from "src/app/core/helper/util";

export class Subscription extends Entity {
    protected static className = 'Subscription';
    protected static idField = 'subscriptionId';

    subscriptionId: number;
    name: string;
    platformFee: number;
    feeCap: number;
    prices: SubscriptionPrice[] = [];
    priceDict: Dictionary<SubscriptionPrice>;


    constructor(subscription?: Partial<Subscription>) {
        super("Subscription", "subscriptionId", "Subscriptions");
        Object.assign(this, subscription);
        this.prices = this.prices.mapObjectsTo(SubscriptionPrice);
        this.priceDict = this.prices.reduce((dict, price) => {
            dict[price.interval] = price;
            return dict;
        }, {} as Dictionary<SubscriptionPrice>);
    }

    public static async loadAll() {
        return await Subscription.fetchArray(Subscription);
    }

    public getPrice(SubscriptionInterval: SubscriptionInterval) {
        return this.priceDict[SubscriptionInterval];
    }

    public get yearlyPrice() { return this.getPrice(SubscriptionInterval.Yearly); }
    public get monthlyPrice() { return this.getPrice(SubscriptionInterval.Monthly); }
    public get quarterlyPrice() { return this.getPrice(SubscriptionInterval.Quarterly); }
    public get dailyPrice() { return this.getPrice(SubscriptionInterval.Daily); }

}


export class SubscriptionPrice {

    subscriptionPriceId: number;
    price: number;
    interval: SubscriptionInterval;

    constructor(subscriptionPrice?: Partial<SubscriptionPrice>) {
        Object.assign(this, subscriptionPrice);
    }
}

export enum SubscriptionInterval {
    Daily = 1,
    Monthly = 2,
    Quarterly = 3,
    Yearly = 4,
}